import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";

const DeviceLink = ({uuid, idx}) => {

    return (
        <div className="row" key={"device-" + idx}>
            <div className="col-12">
                <div className="row">
                    <div className="col-md-3 text-md-end mt-2">
                        <label htmlFor="asset" className="form-label">Dispositivo</label>
                    </div>
                    <div className="col-md-5">
                        <div className="d-flex align-items-center">
                            <input type="text" className="form-control mb-2"
                                   id="asset_name"
                                   defaultValue={uuid}
                                   disabled={true}
                                   readOnly={true}
                            />
                            <Link to={"/asset-management/devices/?uuid=" + uuid} className="mb-2 ms-2"><FontAwesomeIcon icon="eye"/></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeviceLink;